<template>
  <div class="home" v-bind:class="{popup: showForm == true}">
    <Header/>
    <HeaderImg />
    <!-- <HeaderTitle title="Wyszukiwarka samochodów nowych"/> -->
    <!-- <Nav :activeTab="ActiveTab" v-on:activeTab="activeTabUpdate" :ModelCount="ModelCount" v-on:ShowForm="ShowFormUpdate"/> -->

    <Info v-if="ActiveTab == 0"/>
    <ButtonForm />
    <SelectedOptions :ModelList="ModelList" v-on:ModelList="ModelListUpdate" :Fueltype="Fueltype" :Geartype="Geartype" :Price="Price" :Transmissiontype="Transmissiontype" v-on:Price="PriceUpdate" v-on:Fueltype="FueltypeUpdate" v-on:Geartypet="GeartypeUpdate" v-on:Transmissiontype="TransmissiontypeUpdate"/>
    <div class="flex-wrap">
    <Search :ModelList="ModelList" v-on:ModelList="ModelListUpdate" v-if="ActiveTab == 0"/>
    <SearchEngine  :Fueltype="Fueltype" :Geartype="Geartype" :Transmissiontype="Transmissiontype"  v-on:Fueltype="FueltypeUpdate" v-on:Geartypet="GeartypeUpdate" v-on:Transmissiontype="TransmissiontypeUpdate" v-if="ActiveTab == 0"/>
    </div>
    <SearchPrice :Price="Price" v-if="ActiveTab == 2" v-on:Price="PriceUpdate"/>

    <Results v-on:ShowForm="ShowFormUpdate" :ModelList="ModelList" v-on:ModelList="ModelListUpdate" :Fueltype="Fueltype" :Geartype="Geartype" :Price="Price" :Transmissiontype="Transmissiontype" v-on:Price="PriceUpdate" v-on:Fueltype="FueltypeUpdate" v-on:Geartypet="GeartypeUpdate" v-on:Transmissiontype="TransmissiontypeUpdate" v-on:ModelCount="ModelCountUpdate" v-on:pages="pagesUpdate" :page="page" v-on:NumberOffer="NumberOfferUpdate"/>
    <pagination :page="page" :pages="pages" v-on:page="pageUpdate"/>
    <BottomForm :NumberOffer="NumberOffer"/>

    <Footer/>
    <Form :showForm="showForm" v-on:ShowForm="ShowFormUpdate" :NumberOffer="NumberOffer" />

  </div>
</template>

<script>
// @ is an alias to /src
import Header from '@/components/header.vue'
import HeaderImg from '@/components/header-img.vue'
import ButtonForm from '@/components/button.vue'
import HeaderTitle from '@/components/header-title.vue'
import SelectedOptions from '@/components/selected-options.vue'
import Info from '@/components/info.vue'
import Nav from '@/components/nav.vue'
import Search from '@/components/search.vue'
import SearchEngine from '@/components/search-engine.vue'
import SearchPrice from '@/components/search-price.vue'
import Results from '@/components/results.vue'
import Footer from '@/components/footer.vue'
import Pagination from '@/components/pagination.vue'
import BottomForm from '@/components/bottom-form.vue'

import Form from '@/components/form.vue'

export default {
  name: 'home',
  components: {
    Header,
    HeaderImg,
    ButtonForm,
    HeaderTitle,
    SelectedOptions,
    Info,
    Nav,
    Search,
    SearchEngine,
    SearchPrice,
    Results,
    Pagination,
    Footer,
    BottomForm,
    Form
  },
  data: function () {
    return {
      ModelList: [],
      ActiveTab: 0,
      ModelCount: '100+',
      showForm: false,
      ShowDesc: false,
      NumberOffer: false,
      page: 1,
      pages: 1,
      modelListUrl: 'https://webapi.piamarket.pl/models?brand_name%5B%5D=audi',
      Fueltype: Array(
        { 'name': 'Diesel', 'id': 2001, 'selected': false },
        { 'name': 'Benzyna', 'id': 2002, 'selected': false },
        { 'name': 'LPG', 'id': 2003, 'selected': false },
        { 'name': 'Hybryda', 'id': 2004, 'selected': false }
      ),
      Geartype: Array(
        { 'name': 'Manualna', 'id': 4001, 'selected': false },
        { 'name': 'Automatyczna', 'id': 4002, 'selected': false },
        { 'name': 'Półautomatyczna (ASG, Triptronic)', 'id': 4003, 'selected': false },
        { 'name': 'Automatyczna bezstopniowa (CVT)', 'id': 4004, 'selected': false },
        { 'name': 'Automatyczna dwusprzęgłowa (DCT, DSG)', 'id': 4005, 'selected': false }
      ),
      Transmissiontype: Array(
        { 'name': 'Przedni', 'id': 3001, 'selected': false },
        { 'name': 'Tylny', 'id': 3002, 'selected': false },
        { 'name': '4x4 (dołączany automatycznie)', 'id': 3003, 'selected': false },
        { 'name': '4x4 (stały)', 'id': 3004, 'selected': false },
        { 'name': '4x4 (dołączany ręcznie)', 'id': 3005, 'selected': false }
      ),
      Price: {
        from: { 'name': 'od 20 000 PLN', 'value': 20000, 'selected': false },
        to: { 'name': 'od 1000 000 PLN', 'value': 1000000, 'selected': false }
      }
    }
  },
  methods: {
    ModelListUpdate (value) {
      this.ModelList = value
    },
    FueltypeUpdate (value) {
      this.Fueltype = value
    },
    GeartypeUpdate (value) {
      this.Geartype = value
    },
    TransmissiontypeUpdate (value) {
      this.Transmissiontype = value
    },
    PriceUpdate (value) {
      this.Price = value
    },
    ModelCountUpdate (value) {
      this.ModelCount = value
    },
    ShowFormUpdate (value) {
      this.showForm = value;
    },
    NumberOfferUpdate (value) {
      this.NumberOffer = value
    },
    pagesUpdate (value) {
      this.pages = value
      console.log(value)
    },
    pageUpdate (value) {
      this.page = value
      console.log(value)
    },
    getModelList () { // Lista dostępnych modeli Audi
      this.axios.get(this.modelListUrl).then((response) => {
        // this.ModelList = response.data.models
        this.ModelList = response.data.models.map((obj) => {
          obj.selected = false
          return obj
        })
      })
    },
    activeTabUpdate (value) {
      this.ActiveTab = value

      var selected = {
        0: 'Strona główna',
        1: 'Silnik i napęd',
        3: 'Cena',
        99: 'Wyniki wyszykiwania'
      }

      gtag('event', 'Przełączenie', {
        'event_category': 'Zakładka',
        'event_label': 'Wyświetlenie zakładki ' + selected[value],
        'value': selected[value]
      })
    }
  },
  mounted: function () {
    this.getModelList()
  }
}
</script>
<style lang="scss">
.flex-wrap{
  width: 100%;
  display: flex;
  justify-content: flex-end;
  margin: 0px auto -64px auto;
  max-width: 1177.6px;
  min-height: 80px;
  width: 92%;
  @media(max-width:960px){
  width:92%;
  margin: 0 auto;
  justify-content: flex-start;
  }
  @media(max-width:500px){
    width:97%;
  }
}
</style>
